<template>
    <base-button type="primary" class="rsFilterButton" icon="fa fa-filter fa-fw" size="sm" @click="handleClick">Filtrar</base-button>
</template>
<script>
export default {
    name: "filter-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>